"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paper = exports.container = void 0;
var react_1 = require("@emotion/react");
var container = function (state) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n\n  @media print: {\n    height: auto;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  height: 100%;\n\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n\n  @media print: {\n    height: auto;\n  }\n\n  ", "\n\n  ", "\n"])), state.scroll === 'paper' &&
    "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n", state.scroll === 'body' &&
    "\n  overflow-y: auto;\n  overflow-x: hidden;\n  text-align: center;\n  \n  &:after {\n    content: '';\n    display: inline-block;\n    vertical-align: middle;\n    height: 100%;\n    width: 0;\n  }  \n"); };
exports.container = container;
var paper = function (state) { return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 20px;\n  position: relative;\n  overflow-y: auto; // Fix IE11 issue; to remove at some point.\n\n  @media print: {\n    overflow-y: visible;\n    boxshadow: none;\n  }\n\n  ", "\n\n  ", "\n\n", "\n\n", "\n\n", "\n"], ["\n  margin: 20px;\n  position: relative;\n  overflow-y: auto; // Fix IE11 issue; to remove at some point.\n\n  @media print: {\n    overflow-y: visible;\n    boxshadow: none;\n  }\n\n  ", "\n\n  ", "\n\n", "\n\n", "\n\n", "\n"])), state.scroll === 'paper' &&
    "\n    display: flex;\n    flex-direction: column;\n    max-height: calc(100% - 64px);\n", state.scroll === 'body' &&
    "\n    display: inline-block;\n    vertical-align: middle;\n    text-align: left; // initial doesnt work on IE11\n", !state.maxWidth && 'max-width: calc(100% - 64px);', state.fullWidth &&
    "\n    width: calc(100% - 64px);\n", state.fullScreen &&
    "\n    margin: 0;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: none;\n    border-radius: 0;\n"); };
exports.paper = paper;
var templateObject_1, templateObject_2;
// &.${dialogClasses.paperScrollBody} {
//   margin: 0;
//   maxWidth: 100%;
// };
// ...(ownerState.maxWidth === xs && {
//   maxWidth:
//     theme.breakpoints.unit === px
//       ? Math.max(theme.breakpoints.values.xs; 444)
//       : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`;
//   [`&.${dialogClasses.paperScrollBody}`]: {
//     [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs; 444) + 32 * 2)]: {
//       maxWidth: calc(100% - 64px);
//     };
//   };
// });
// ...(ownerState.maxWidth !== xs && {
//   maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`;
//   [`&.${dialogClasses.paperScrollBody}`]: {
//     [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
//       maxWidth: calc(100% - 64px);
//     };
//   };
// });
//# sourceMappingURL=Dialog.style.js.map